export function rigDetailsCloseOnOutsideClick(root: ParentNode = document): void {
    document.addEventListener("click", (event) => {
        const target = event.target;
        if (!(target instanceof Node)) {
            return;
        }
        root.querySelectorAll("details[data-ocp-close-on-outside-click][open]").forEach((el) => {
            if (!el.contains(target)) {
                el.removeAttribute("open");
            }
        });
    });
}
